export default function MyFriendsAndFamily() {
  return (
    <div className="container-fluid bg-light min-vh-100 p-4">
      <div className="row mt-4 mb-5">
        {/* Sidebar */}
        <div className="col-md-3 mb-4 ">
          <div className="list-group rounded">
            <a
              href="/"
              className="list-group-item list-group-item-action border-0"
            >
              <i className="fa-regular fa-user me-2" />
              My Profile
            </a>
            <a
              href="/"
              className="list-group-item list-group-item-action border-0"
            >
              <i className="fa-regular fa-bookmark me-2" />
              My Bookings
            </a>
            <a
              href="/"
              className="list-group-item list-group-item-action border-0 text-success fw-semibold"
            >
              <i className="fa-solid fa-users me-2" />
              My Family & Friends
            </a>
          </div>
        </div>

        {/* Profile Content */}
        <div className="col-md-5">
          <h4 className="fw-semibold mb-4">Primary Account</h4>

          {/* Profile Items */}
          <div className="d-flex align-items-center justify-content-between bg-white p-3 rounded mb-3">
            <div className="d-flex align-items-center">
              <img
                style={{ objectFit: "contain" }}
                height={50}
                width={50}
                src="https://t4.ftcdn.net/jpg/02/18/93/97/360_F_218939757_YqHgeD3BAANU87y2Kc10Y40HNVgDv5rK.jpg"
                alt="profile"
                className="rounded-circle me-3"
              />
              <div>
                <div
                  className="fw-bold small text-uppercase py-2"
                  style={{ color: "#F88922" }}
                >
                  Name
                </div>
                <div className="py-2">Mr. Ashiqul Islam</div>
              </div>
            </div>
          </div>

          <h4 className="fw-semibold mb-2 mt-5">Friends & Family</h4>

          <div className="d-flex align-items-center mb-3 text-secondary">
            <i className="fa-solid fa-circle-info me-2" />
            <div>You have 1 additional member account</div>
          </div>

          {/* Profile Items */}
          <div className="d-flex align-items-center justify-content-between bg-white p-3 rounded mb-3">
            <div className="d-flex align-items-center">
              <div>
                <div
                  className="fw-bold small text-uppercase py-2"
                  style={{ color: "#F88922" }}
                >
                  Name
                </div>
                <div className="py-2">Mr. Ashiqul Islam</div>
              </div>
            </div>
            <a
              href="/"
              className="text-success small fw-semibold text-decoration-none"
            >
              Edit
            </a>
          </div>

          <button className="btn btn-outline-success px-4" type="button">
            <i className="fa-solid fa-user-plus me-2" />
            Add Member
          </button>
        </div>
      </div>
    </div>
  );
}
